<template>
    <b-container fluid id="layout_section_component"
                 v-if="auth">
        <b-row>
            <main-menu :active="'dashboard'" :title="'Dashboard'"></main-menu>
            <info-modal></info-modal>
            <dashboard-first-time-content v-if="!mobileMenu"></dashboard-first-time-content>
        </b-row>
    </b-container>
</template>

<script>
    import MainMenu from '../menu/MainMenu.vue'
    import DashboardFirstTimeContent from '../content/DashboardFirstTimeContent.vue'
    import InfoModal from '../modals/InfoModal';

    export default {
        dependencies: ['api', 'status', 'user'],
        props: ['auth', 'mobile, user'],
        components: {InfoModal, MainMenu, DashboardFirstTimeContent },
        computed: {
            mobileMenu () {
                return this.$store.getters.mobileMenu
            }
        },
        beforeCreate () {
            if (!this.$store.getters.checkAuth) {
                this.$http.get(this.api.auth.user).then(response => {
                    this.user.fetchData(response.data).then(() => {
                        if (this.$store.getters.user.position != 0) {
                            this.$router.push({ name: 'Dashboard' })
                        }
                    })
                }, error => {
                    switch (error.status) {
                        case 401:
                            this.$store.commit('setRedirect', { name: 'Send' })
                            break
                        default:
                            this.status['status' + error.status](next)
                            break
                    }

                })
            } else {
                if (this.$store.getters.user.position != 0) {
                    this.$router.push({ name: 'Dashboard' })
                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/pages/DashboardFirstTime.vue